import React from 'react'
import styled from 'styled-components'
import Reveal from 'react-reveal/Reveal'
import Share from './Share'

const Wrapper = styled.div`
  background: ${props => props.theme.colors.secondary};
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  @media screen and (min-width: ${props => props.theme.responsive.medium}) {
    min-height: 25vh;
  }
`

const Info = styled.div`
  max-width: 800px;
  padding: 4rem 2rem 4rem;
`

const Heading = styled.h3`
  font-family: 'PT Serif', serif;
  font-size: 1.25rem;
  font-weight: bold;
  line-height: 1.4;
  margin: 0 0 2rem 0;
  position: relative;
  @media screen and (min-width: ${props => props.theme.responsive.medium}) {
    font-size: 1.75rem;
  }
`

const Text = styled.div`
  position: relative;
  line-height: 1.5;
  margin: 0 0 2rem 0;
  p {
    font-size: 1.1rem;
    @media screen and (min-width: ${props => props.theme.responsive.medium}) {
      font-size: 1.25rem;
    }
    &:last-child {
      margin: 0;
    }
  }
`

const Intro = (props) => {
  console.log(props)

  return (
    <Wrapper>
      <Reveal>
        <Info>
          <Heading>Share with your network</Heading>
          <Text>
            <p>Please share this page with construction employers and tradespeople in your network.</p>
          </Text>
          <Share socialConfig={{
            twitterHandle: '@thisisbcca',
            config: {
              url: 'http://voices.bccassn.com',
              title: `Join me in protesting Premier Horgan's new Community Benefits Agreement.`
            }
          }} />
        </Info>
      </Reveal>
    </Wrapper>
  )
}

export default Intro



// WEBPACK FOOTER //
// ./src/components/Social.js